<div class="slider-container">
    <div class="outofstock" [style.margin-left.px]="todayPx" [style.width.px]="daysToArrivePx"></div>
    <div class="has-stock" [style.margin-left.px]="todayPx" [style.width.px]="daysOfSupplyPx"></div>
    <div class="days-to-arrive" [style.margin-left.px]="todayPx" [style.width.px]="daysToArrivePx"></div>
    <div class="month" *ngFor="let month of allMonths, index as ix" [style.margin-left.px]="70 * ix">
        <div #start [class.drag-circle]="startOfSelection(month)"
            (mousedown)="circleMouseDown($event, ix, true)"
            [style.margin-left.px]="(70 * ((100 - getAvailablePercent(month, ix)) / 100)) - 4"></div>
        <div #end [class.drag-circle]="endOfSelection(month)" [style.margin-left.px]="65"
            (mousedown)="circleMouseDown($event, ix, false)"></div>
        <div [class.selected]="getMonthlyOrders(selectedYear, month)"
            [style.margin-left.px]="70 * ((100 - getAvailablePercent(month, ix)) / 100)"
            [style.width.%]="getAvailablePercent(month, ix)"></div>
    </div>
</div>